/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import { SpinnerIcon } from '../../../images/icons/Spinner/Spinner'

import './styles/Loading.css'

export default class Loading extends React.Component<any, any> {
    render() {
        return (
            <div
                className=
                {`loading ${this.props.className ? this.props.className : ''}`}
                style={this.props.style ? this.props.style : null}
            >
                <SpinnerIcon />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Loading/Loading.tsx